import React from 'react';
import PropTypes from 'prop-types';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Table = ({ tableRowsCollection, backgroundColor }) => {
    const rows = tableRowsCollection.items;

    return (
        <div className='mt-40'>
            <div className='grid grid-cols-1 sm:border sm:border-black sm:mt-35'>
                {rows.map((row, i) => {
                    return (
                        <div
                            className={`${i === (rows.length - 1) ? '' : 'sm:border-b'}`}
                            key={i}>
                            {row.rowTitle && (
                                <div className='sm:p-20 mt-30 mb-20 sm:m-0 col-span-1 type-style-5 font-[500] sm:type-style-3'>{row.rowTitle}</div>
                            )}
                            <div className='sm:flex sm:gap-0 grid gap-1 bg-black border border-black sm:bg-white/0 sm:border-none sm:flex-row w-full type-style-8'>
                                {(row.column1Title || row.column1) && (
                                    <div
                                        className={`p-20 flex flex-col w-full ${(row.column2Title || row.column2) ? 'sm:border-r' : ''}`}
                                        style={{backgroundColor: backgroundColor}}>
                                        <div>{row?.column1Title}</div>
                                        <div>{row?.column1}</div>
                                    </div>
                                )}
                                {(row.column2Title || row.column2) && (
                                    <div
                                        className={`p-20 flex flex-col w-full ${(row.column3Title || row.column3) ? 'sm:border-r' : ''}`}
                                        style={{backgroundColor: backgroundColor}}>
                                        <div>{row?.column2Title}</div>
                                        <div>{row?.column2}</div>
                                    </div>
                                )}
                                {(row.column3Title || row.column3) && (
                                    <div
                                        className='p-20 flex flex-col w-full'
                                        style={{backgroundColor: backgroundColor}}>
                                        <div>{row?.column3Title}</div>
                                        <div>{row?.column3}</div>
                                    </div>
                                )}
                            </div>

                        </div>
                    );
                })}
            </div>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

Table.propTypes = {
    tableRowsCollection: PropTypes.object.isRequired,
    backgroundColor: PropTypes.string,
};

export default Table;
